import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import CardCompile from '../components/CardCompile'
import CardCorners from '../components/CardCorners'
import CardUpload from '../components/CardUpload'
import CardUser from '../components/CardUser'
import Order from '../components/Order'

const Form = (props) => {
  let { formIsValid, formControls, currentProduct, targetPrice, handleChange, handleRemoveFile, handleSubmit, sendingForm } = props

  return (
    <div className="c-personalizer__form-container">
      
      <form method="post" enctype="multipart/form-data" action="/mat-personaliseren/bedankt/" onSubmit={handleSubmit}>
        <input type="hidden" name="form_id" value="99999" />
        <input type="hidden" name="form_title" value="Mat personaliseren" />
        <input type="hidden" name="page" value="Mat samenstellen" />
        <input type="hidden" name="url" value={window.location.href} />
        <input type="hidden" name="hubspot_form" value='f719a762-c3aa-4c92-a2ac-e65bd32f7b46' />
        <input type="text" name="first_name" value="" className="u-obscure" placeholder="Laat dit veld leeg" />
        <input type="hidden" name="targetPrice" value={targetPrice} />

        <CardCompile 
          formControls={formControls}
          handleChange={handleChange}
          product={currentProduct}
        />

        <CardCorners 
          formControls={formControls}
          handleChange={handleChange}
        />

        <CardUpload 
          formControls={formControls}
          handleChange={handleChange}
          handleRemoveFile={handleRemoveFile}
        />

        <CardUser 
          formControls={formControls}
          handleChange={handleChange}
        />

        <Order 
          formControls={formControls}
          product={currentProduct}
          formIsValid={formIsValid}
          targetPrice={targetPrice}
          sendingForm={sendingForm}
        />

      </form>

    </div>
  )
}

export default Form



// WEBPACK FOOTER //
// ./src/js/personalizer/components/Form.js